import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LanguageService } from 'src/app/shared/services/language.service';

@Component({
  selector: 'app-migratory-processes',
  templateUrl: './migratory-processes.component.html',
  styleUrls: ['./migratory-processes.component.scss']
})
export class MigratoryProcessesComponent implements OnInit {
  show = false;
  link: any;

  constructor(
    private languageService: LanguageService,
    private sanitizer: DomSanitizer
  ) {

  }
  ngOnInit(): void {
    window.scroll({ top: 0 });
    this.languageService.selectedLanguage.subscribe(lang => {
      lang ?
        this.link = this.sanitizer.bypassSecurityTrustResourceUrl(`https://docs.oncubatravel.com/${lang}/contact`) :
        this.link = this.sanitizer.bypassSecurityTrustResourceUrl(`https://docs.oncubatravel.com/es/contact`);
      this.show = true;
    });
  }
}
